import {
	ORDER_CREATE_FAIL,
	ORDER_CREATE_REQUEST,
	ORDER_CREATE_RESET,
	ORDER_CREATE_SUCCESS,
	ORDER_DETAILS_FAIL,
	ORDER_DETAILS_REQUEST,
	ORDER_DETAILS_SUCCESS,
	ORDER_LIST_FAIL,
	ORDER_LIST_REQUEST,
	ORDER_LIST_SUCCESS,
	ORDER_MINE_LIST_FAIL,
	ORDER_MINE_LIST_REQUEST,
	ORDER_MINE_LIST_SUCCESS,
	ORDER_PAY_FAIL,
	ORDER_PAY_REQUEST,
	ORDER_PAY_RESET,
	ORDER_PAY_SUCCESS,
	ORDER_SEND_DATA_FAIL,
	ORDER_SEND_DATA_RESET,
	ORDER_SEND_DATA_SUCCESS,
	ORDER_SEND_DATA_REQUEST,
	ORDER_DETAILS_RESET,
} from "../constants/orderConstants";

export const orderCreateReducer = (state = {}, action) => {
	switch (action.type) {
		case ORDER_CREATE_REQUEST:
			return { loading: true };
		case ORDER_CREATE_SUCCESS:
			return { loading: false, success: true, order: action.payload };
		case ORDER_CREATE_FAIL:
			return { loading: false, error: action.payload };
		case ORDER_CREATE_RESET:
			return {};
		default:
			return state;
	}
};

export const orderDetailsReducer = (state = { loading: true }, action) => {
	switch (action.type) {
		case ORDER_DETAILS_REQUEST:
			return { loading: true };
		case ORDER_DETAILS_SUCCESS:
			return { loading: false, order: action.payload };
		case ORDER_DETAILS_FAIL:
			return { loading: false, error: action.payload };
		case ORDER_DETAILS_RESET:
			return {};
		default:
			return state;
	}
};


export const orderPayReducer = (state = {}, action) => {
	switch (action.type) {
		case ORDER_PAY_REQUEST:
			return { loading: true };
		case ORDER_PAY_SUCCESS:
			return { loading: false, success: true };
		case ORDER_PAY_FAIL:
			return { loading: false, error: action.payload };
		case ORDER_PAY_RESET:
			return {};
		default:
			return state;
	}
};

export const orderMineListReducer = (state = { orders: [] }, action) => {
	switch (action.type) {
		case ORDER_MINE_LIST_REQUEST:
			return { loading: true };
		case ORDER_MINE_LIST_SUCCESS:
			return { loading: false, orders: action.payload };
		case ORDER_MINE_LIST_FAIL:
			return { loading: false, error: action.payload };
		default:
			return state;
	}
};

export const orderListReducer = (state = { orders: [] }, action) => {
	switch (action.type) {
		case ORDER_LIST_REQUEST:
			return { loading: true };
		case ORDER_LIST_SUCCESS:
			return {
				loading: false,
				orders: action.payload.orders,
				pages: action.payload.pages,
				page: action.payload.page,
			};
		case ORDER_LIST_FAIL:
			return { loading: false, error: action.payload };
		default:
			return state;
	}
};




export const orderSendDataReducer = (state = { sendData: [] }, action) => {
	switch (action.type) {
		case ORDER_SEND_DATA_REQUEST:
			return { loading: true };
		case ORDER_SEND_DATA_SUCCESS:
			return { loading: false, success: true, sendData: action.payload };
		case ORDER_SEND_DATA_FAIL:
			return { loading: false, error: action.payload };
		case ORDER_SEND_DATA_RESET:
			return {};
		default:
			return state;
	}
};
